import { render } from "./PageJadwalAssessment.vue?vue&type=template&id=9a15a038"
import script from "./PageJadwalAssessment.vue?vue&type=script&lang=js"
export * from "./PageJadwalAssessment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__